export const DATE_PICKER_OPTIONS = [
  { label: 'Full Import', value: '@0' },
  { label: 'Last Flow Execution Created At', value: '%LAST_FLOW_EXECUTION_CREATED_AT%' },
  { label: 'Last Flow Execution Updated At', value: '%LAST_FLOW_EXECUTION_UPDATED_AT%' },
  { label: 'Current Execution Updated At', value: '%CURRENT_EXECUTION_CREATED_AT%' },
  { label: 'Date Picker', value: 'DATE_PICKER' }
]
